import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

let isRefreshing = false;
let refreshSubscribers: ((token: string) => void)[] = [];

const subscribeTokenRefresh = (cb: (token: string) => void) => {
  refreshSubscribers.push(cb);
};

const onRefreshed = (token: string) => {
  refreshSubscribers.forEach(cb => cb(token));
  refreshSubscribers = [];
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    console.error('API Error:', error);
    
    const originalRequest = error.config;
    
    if (!error.response) {
      return Promise.reject(error);
    }
    
    // 处理系统过期
    if (error.response?.data?.systemExpired) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.setItem('systemExpiredMessage', error.response.data.message || '系统已过期，请联系商务续费');
      window.location.href = '/login';
      return Promise.reject(error);
    }
    
    if (error.response?.status === 401) {
      const isLoginRequest = originalRequest.url?.includes('/auth/login');
      
      if (isLoginRequest) {
        return Promise.reject(error);
      }
      
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return Promise.reject(error);
    }
    
    if (error.response?.status === 403 && !originalRequest._retry) {
      const isSystemExpired = error.response?.data?.systemExpired;
      
      if (isSystemExpired) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.setItem('systemExpiredMessage', error.response.data.message || '系统已过期，请联系商务续费');
        window.location.href = '/login';
        return Promise.reject(error);
      }
      
      originalRequest._retry = true;
      
      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const response = await axios.get('/api/auth/refresh-permissions', {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          });
          
          const { token, user } = response.data;
          localStorage.setItem('token', token);
          localStorage.setItem('user', JSON.stringify(user));
          
          isRefreshing = false;
          onRefreshed(token);
          
          originalRequest.headers['Authorization'] = `Bearer ${token}`;
          return axiosInstance(originalRequest);
        } catch (refreshError: any) {
          isRefreshing = false;
          if (refreshError?.response?.data?.systemExpired) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.setItem('systemExpiredMessage', refreshError.response.data.message || '系统已过期，请联系商务续费');
            window.location.href = '/login';
          }
          return Promise.reject(refreshError);
        }
      } else {
        return new Promise((resolve) => {
          subscribeTokenRefresh((token: string) => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }
    }
    
    return Promise.reject(error);
  }
);

const api = axiosInstance;
export default api;
